import { map, html, includes, sel, strMap } from 'fxjs/es';
import { makeCloseIcon } from '@services/MarppleShop/marppleShopStudioApp/components/atoms/Icon/index.ts';
import { DotIcon } from '@services/MarppleShop/shared/components/atoms/Icon/foundation_icons.ts';
import { font } from '@services/MarppleShop/shared/typography/index.ts';
import { MShopUtilConstantS } from '../../../MShop/Util/S/Constant/module/MShopUtilConstantS.js';
import { UtilS } from '../../../Util/S/Function/module/UtilS.js';
import {
  LNB_INVITE_MENU,
  LNB_IS_NOT_AGREE_MENUS,
  LNB_MENU_ID,
  LNB_TOP_CUSTOM_SWITCH_MENU,
  LNB_TOP_MENUS,
  MPS_LNB_MENUS,
  MPS_LNB_SUPPORT_MENUS,
} from './lnb-data.ts';
import settings_klass from '../F/setting_menu.module.scss';
import { CreatorOnboardingBanner } from '@services/MarppleShop/marppleShopStudioApp/components/cells/CreatorOnboardingBanner/CreatorOnboardingBanner.ts';
import { classes } from '@services/MarppleShop/shared/util/index.ts';

/**
 * @param link
 * @param user
 * @param domain_name
 * @param active_page_name
 * @param title
 * @param title_suffix {string}
 * @param page_name
 * @param icon
 * @param dataShow
 * @param blank
 * @param is_app
 * @param question_count
 * @param solution_count
 * @return {*}
 */
const makeLi = ({
  link,
  user,
  domain_name,
  active_page_name,
  title,
  title_suffix,
  page_name,
  icon,
  dataShow,
  blank,
  is_app,
  question_count,
  solution_count = 0,
  klass,
}) => {
  const is_question_count_show = question_count > 0 && page_name === LNB_MENU_ID.QUESTION_LIST;
  const is_solution_count_show = solution_count > 0 && page_name === LNB_MENU_ID.SOLUTIONS;

  return html`<li data-show="${!dataShow || dataShow(user, is_app)}">
    <a
      class="menu${page_name == 'question-list' ? ' question-list-a' : ''} ${settings_klass.menu} ${klass ??
      ''}"
      href="${blank
        ? blank(domain_name) + '" target="_blank'
        : `/${T.lang}/${UtilS.escape(domain_name)}/settings/${link}`}"
      data-active="${active_page_name === page_name}"
    >
      ${icon ? html`<span class="${settings_klass.icon}">${icon}</span>` : ''}
      <span class="${font('14_medium')}">
        ${typeof title === 'string' ? T(title, { br: '<br />' }) : title}
      </span>
      ${title_suffix ? html`<span class="${settings_klass.title_suffix}">${title_suffix}</span>` : ''}
      ${is_question_count_show ? html`<span class="setting-menu-count">${question_count}</span>` : ''}
      ${is_solution_count_show
        ? html`<span class="setting-menu-count solution">${solution_count}</span>`
        : ''}
    </a>
  </li>`;
};

const makeMenu =
  ({ question_count, domain_name, active_page_name, user, is_app, klass = '', solution_count = 0 }) =>
  ({ id, title, title_suffix, page_name, icon, dataShow, collapses, blank, link }) => {
    const is_customer_inquiry = id === LNB_MENU_ID.CUSTOMER_INQUIRY;

    if (collapses?.length) {
      return html`<li data-show="${!dataShow || dataShow(user, is_app)}">
        <div
          is="collapse"
          class="collapse${includes(active_page_name, collapses.map(sel('page_name')))
            ? ' opened'
            : ''} ${klass}"
        >
          <a class="menu collapse-anchor ${settings_klass.menu}">
            <span class="${font('14_medium')} ${settings_klass.title}">
              ${icon
                ? html` <span class="${settings_klass.icon}">
                    ${icon}
                    ${is_customer_inquiry && (question_count || solution_count)
                      ? DotIcon({ html, klass: settings_klass.dot })
                      : ''}
                  </span>`
                : ''}
              ${typeof title === 'string' ? T(title, { br: '<br />' }) : title}
              ${title_suffix
                ? html`<span class="suffix ${settings_klass.title_suffix}">${title_suffix}</span>`
                : ''}
            </span>
          </a>
          <div class="collapse-content">
            <ul>
              ${strMap((data) => {
                return makeLi({
                  user,
                  domain_name,
                  active_page_name,
                  is_app,
                  question_count,
                  solution_count,
                  ...data,
                });
              }, collapses)}
            </ul>
          </div>
        </div>
      </li>`;
    } else {
      return makeLi({
        user,
        domain_name,
        active_page_name,
        title,
        title_suffix,
        link,
        page_name,
        icon,
        dataShow,
        blank,
        is_app,
        question_count,
        solution_count,
      });
    }
  };

const SOOP_LNB_MENUS = MPS_LNB_MENUS.filter(({ id }) => {
  return [LNB_MENU_ID.PRODUCT_MANAGEMENT, 'adjustments', 'analytics'].includes(id);
});

const makeMenusHtml = ({
  question_count,
  domain_name,
  page_name: active_page_name,
  user,
  is_app,
  is_user_custom_enable,
  creator_studio,
  solution_count,
}) => {
  const is_soop_crew = user._.crew.id === MShopUtilConstantS.SOOP_MARPPLESHOP_CREW_ID;
  const is_ness = UtilS.isNessApp();

  if (sel('_.store.invited_store_id', user) && !sel('_.store.is_invite_info', user)) {
    return makeMenu({ domain_name, active_page_name, user, is_app })(LNB_INVITE_MENU);
  }

  if (!sel('_.store.is_agree', user)) {
    return strMap(
      makeMenu({ question_count, domain_name, active_page_name, user, is_app, solution_count }),
      LNB_IS_NOT_AGREE_MENUS,
    );
  }

  if (is_ness) {
    return html`
      ${strMap(
        makeMenu({ question_count, domain_name, active_page_name, user, is_app, solution_count }),
        is_user_custom_enable
          ? map((menu) => (menu.id === 'make_products' ? LNB_TOP_CUSTOM_SWITCH_MENU : menu), LNB_TOP_MENUS)
          : LNB_TOP_MENUS,
      )}
    `;
  }

  return html`
    <ul class="${settings_klass.menu_top}">
      ${strMap(
        makeMenu({ question_count, domain_name, active_page_name, user, is_app, solution_count }),
        is_soop_crew ? SOOP_LNB_MENUS : MPS_LNB_MENUS,
      )}
    </ul>
    <ul class="${settings_klass.menu_bottom}">
      <div data-show="${T.lang === 'kr'}" class="${settings_klass.support_center}">
        <div class="${settings_klass.support} ${settings_klass.title} ${font('12_medium')}">
          ${ET('mps2::seller_studio::navigation::creator_support')}
        </div>
        ${strMap((data) => {
          return makeLi({
            user,
            domain_name,
            active_page_name,
            is_app,
            question_count,
            solution_count,
            ...data,
            klass: settings_klass.support,
          });
        }, MPS_LNB_SUPPORT_MENUS)}
      </div>

      <div class="${settings_klass.button_list}">
        ${creatorStudioOnboardingHtml({ creator_studio, domain_name })}

        <li class="live_chat">
          <button type="button" class="${classes(settings_klass.button_40, font('14_medium'))}">
            <span class="${settings_klass.button_40_icon}">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M14.6008 13.0599L14.2277 11.9399C14.4876 11.3733 14.6408 10.7533 14.6608 10.1266C14.6875 9.41326 14.5475 8.69992 14.2543 8.04659C13.9678 7.39992 13.528 6.81326 12.9816 6.35326C12.4418 5.89992 11.7887 5.56659 11.0957 5.39326C10.7825 5.31326 10.4693 5.27326 10.1428 5.25992C10.0895 4.75992 9.94289 4.27326 9.72299 3.81326C9.42979 3.20659 9.00331 2.67992 8.47021 2.26659C7.94378 1.85326 7.32405 1.56659 6.671 1.42659C6.01129 1.28659 5.33159 1.29992 4.68521 1.45992C4.03217 1.61992 3.42577 1.93326 2.91266 2.36659C2.39955 2.79992 1.9864 3.33992 1.71319 3.95326C1.43997 4.56659 1.31336 5.23326 1.33335 5.90659C1.36001 6.57993 1.53327 7.23326 1.84646 7.82659L1.36667 9.27326C1.32669 9.39326 1.32003 9.51993 1.34668 9.64659C1.37334 9.76659 1.43997 9.87993 1.5266 9.97326C1.61323 10.0599 1.72651 10.1266 1.85312 10.1533C1.97307 10.1799 2.10635 10.1733 2.22629 10.1333L3.67232 9.65326C4.16544 9.91326 4.7052 10.0799 5.25829 10.1399C5.28495 10.8866 5.48486 11.6199 5.85803 12.2733C6.25785 12.9799 6.8376 13.5733 7.53062 13.9933C8.22365 14.4133 9.0233 14.6466 9.82961 14.6666C9.86959 14.6666 9.90958 14.6666 9.94956 14.6666C10.6359 14.6666 11.309 14.5133 11.9354 14.2266L13.0549 14.5999C13.2681 14.6733 13.5013 14.6799 13.7212 14.6266C13.9411 14.5733 14.141 14.4599 14.301 14.2999C14.4609 14.1399 14.5742 13.9399 14.6275 13.7199C14.6808 13.4999 14.6675 13.2666 14.6008 13.0533V13.0599ZM13.0415 12.0799L13.4947 13.4599L13.428 13.4999L12.0753 13.0466C11.922 12.9933 11.7554 13.0066 11.6155 13.0866C11.0757 13.3733 10.4627 13.5133 9.86293 13.4999C9.24987 13.4866 8.65679 13.3066 8.13036 12.9933C7.60392 12.6799 7.17078 12.2333 6.87091 11.6999C6.5977 11.2199 6.4511 10.6733 6.42445 10.1199C6.99086 10.0333 7.53729 9.83993 8.0304 9.53993C8.68345 9.14659 9.22321 8.59326 9.60304 7.92659C9.86959 7.45993 10.0362 6.94659 10.1162 6.41993C10.3494 6.43326 10.5826 6.45993 10.8092 6.51326C11.3289 6.64659 11.8221 6.89326 12.2286 7.23992C12.635 7.58659 12.9682 8.02659 13.1881 8.51326C13.408 8.99993 13.508 9.53993 13.4947 10.0799C13.4747 10.6133 13.3347 11.1466 13.0815 11.6199C13.0082 11.7599 12.9949 11.9266 13.0415 12.0799Z"
                  fill="#1C75FF"
                />
              </svg>
            </span>

            <span class="${classes(settings_klass.button_40_text, font('14_medium'))}"
              >${ET('studio_kakao::studio_usage_inquiry')}</span
            >
          </button>
        </li>

        <li>
          <a
            href="https://pf.kakao.com/_EfTDn"
            class="${classes(settings_klass.button_kakao_channel, 'external-url')}"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span class="${settings_klass.button_kakao_channel_icon}">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                <g clip-path="url(#clip0_24060_9204)">
                  <path
                    d="M7.00069 0.5C3.41073 0.5 0.5 3.19212 0.5 6.51259C0.5 8.96547 1.52708 10.1355 2.93363 11.2025L2.94051 11.2052V14.083C2.94051 14.2191 3.09587 14.2961 3.20449 14.2163L5.66975 12.3849L5.72337 12.4083C6.13723 12.4839 6.56346 12.5252 7.00069 12.5252C10.5906 12.5252 13.5014 9.83305 13.5014 6.51259C13.5014 3.19212 10.5906 0.5 7.00069 0.5Z"
                    fill="black"
                  />
                  <path
                    d="M10.6692 5.77567C10.9098 6.02316 11.0308 6.35865 11.0308 6.79312V8.84865H10.1673V6.90037C10.1673 6.45214 9.90608 6.21015 9.5046 6.21015C9.05637 6.21015 8.76763 6.48514 8.76763 7.04061V8.84865H7.90417V4.08313H8.76763V5.87604C8.97525 5.56118 9.30936 5.40719 9.76584 5.40719C10.1343 5.40719 10.4354 5.52819 10.6692 5.77567Z"
                    fill="#FAE100"
                  />
                  <path
                    d="M6.16762 7.06532C6.004 7.65516 5.45815 8.03602 4.82156 8.03602C3.98698 8.03602 3.29263 7.39393 3.29263 6.50572C3.29263 5.61751 3.9031 4.96304 4.82156 4.96304C5.47053 4.96304 6.03425 5.35352 6.17724 5.98049H7.1177C6.89771 4.82692 6.0095 4.06934 4.82156 4.06934C3.45488 4.06934 2.3728 5.08816 2.3728 6.50572C2.3728 7.92328 3.45625 8.9421 4.82156 8.9421C5.99713 8.9421 6.87984 8.19826 7.11082 7.06532H6.16762Z"
                    fill="#FAE100"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_24060_9204">
                    <rect width="13" height="13.7493" fill="white" transform="translate(0.5 0.5)" />
                  </clipPath>
                </defs>
              </svg>
            </span>

            <span class="${classes(settings_klass.button_kakao_channel_text, font('14_medium'))}"
              >${ET('studio_kakao::operation_know_how')}</span
            >
          </a>
        </li>
      </div>
    </ul>
  `;
};

/**
 * @param data {{ domain_name: string; creator_studio?: Locals['creator_studio']  }}
 * */
const creatorStudioOnboardingHtml = ({ creator_studio, domain_name }) => {
  if (!creator_studio?.onboarding || creator_studio.onboarding.is_completed || T.lang !== 'kr') {
    return '';
  }

  return html` <li class="${settings_klass.onboarding}">
    ${new CreatorOnboardingBanner({
      ...creator_studio.onboarding,
      link: `/${T.lang}/${UtilS.escape(domain_name)}/settings/welcome`,
    }).toHtml()}
  </li>`;
};

/**
 * @param domain_name
 * @param page_name
 * @param user
 * @param solution_count
 * @param data {{ question_count: number; creator_studio?: Locals['creator_studio']  }}
 * @return {*}
 */
export const makeStoreSettingsMenuHtml = (
  { domain_name, page_name = '', user, solution_count = 0 },
  data = {},
) => {
  const { is_app = false, question_count, creator_studio } = data;

  const is_user_custom_enable = data?.store?.is_user_custom_enable ?? false;

  return html`
    <nav id="creator_settings_menu" class="setting_aside">
      <div class="only-mobile close-btn">
        <button type="button" class="btn btn-icon">${makeCloseIcon({ html })}</button>
      </div>
      <div class="inner_menu_wrapper ${settings_klass.menu_items_wrapper}">
        <ul class="menu_items ${settings_klass.menu_items}">
          ${makeMenusHtml({
            question_count,
            domain_name,
            page_name,
            user,
            is_app,
            creator_studio,
            is_user_custom_enable,
            solution_count,
          })}
        </ul>
      </div>
    </nav>
  `;
};
